import { Check } from 'lucide-react';

// Ported from roammyway_funnel's app/components/auth/steps/PasswordRequirementsChecklist.tsx
// -- reflects only the rule actually enforced server-side by the shared
// signup endpoint (min 8 chars, see app/api/auth/signup/route.ts).
const REQUIREMENTS = [{ id: 'length', label: '8+ characters', test: (password) => password.length >= 8 }];

export default function PasswordRequirementsChecklist({ password }) {
  return (
    <ul className="mt-2 space-y-1">
      {REQUIREMENTS.map((req) => {
        const met = req.test(password);
        return (
          <li
            key={req.id}
            className={`flex items-center gap-1.5 font-brand text-[12.5px] transition-colors ${
              met ? 'text-brand-success' : 'text-brand-text-secondary'
            }`}
          >
            <span
              className={`flex h-3.5 w-3.5 items-center justify-center rounded-full border transition-colors ${
                met ? 'border-brand-success bg-brand-success' : 'border-brand-border'
              }`}
            >
              {met && <Check className="h-2.5 w-2.5 text-white" strokeWidth={3} aria-hidden="true" />}
            </span>
            {req.label}
          </li>
        );
      })}
    </ul>
  );
}
